module.exports = __webpack_public_path__ + "8ca3eb1a3e5a246e0c303445c54b953e.pdf";